import React, { useState, useEffect } from 'react';

const Timer = (props) => {
  const { initialSeconds } = props;
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSeconds((sec) => sec - 1);
    }, 1000);

    if (seconds === 0) {
      clearInterval(intervalId);
    }

    return () => clearInterval(intervalId);
  }, [seconds]);

  return <div>{seconds}s</div>;
};

export default Timer;
